
<template>
  <div class="question">
    <a-spin class="load"
            v-show="loading" />
    <div class="top">
<!--      <span class="icon"-->
<!--            @click="goHistory"><img class="goHistory"-->
<!--             src="../../../assets/image/08.png"-->
<!--             alt=""></span>-->
<!--      <span class="iconText">专家回复</span>-->
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/homePage'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
          专家回复
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content">
      <div class="contMes">
        <div class="mesList">
          <a-list item-layout="vertical"
                  size="large"
                  :data-source="listData">
            <a-list-item slot="renderItem"
                         key="item.title"
                         slot-scope="item">
              <a-list-item-meta :description="item.description">
                <div slot="title">
                  <div class="prepare">
                    <div class="prepareTop">
                      <div class="bookName">{{item.lessonTitle}}</div>
                      <p class="bookTitle">{{item.textContent}}</p>
                      <a-row>
                        <a-col :span="1">
                          <img class="photoImg"
                               :src="$userINfoBasePath+'/'+item.userPhoto"
                               alt="" />
                        </a-col>
                        <a-col :span="23">
                          <span class="userName">{{item.userName}}</span><span class="userSchool">{{item.userClassInfo=!item.userClassInfo?'测试':item.userClassInfo}}</span>
                          <p class="questionText">{{item.content}}</p>
                          <p class="date">{{format.formatDayTime(item.createDate)}}</p>
                        </a-col>
                        <div class="clearFix"></div>
                      </a-row>
                    </div>
                    <div class="replayMess"
                         v-for="(t,index) in item.replyList"
                         :key="index">
                      <span class="spanImg"><img class="photoImg"
                             :src="$userINfoBasePath+'/'+t.userPhoto"
                             alt="" /></span>
                      <span class="fuhao">回复</span>
                      <span class="userSchool">{{t.recuserName=!t.recuserName?'测试':t.recuserName}}</span>
                      <p class="questionText">{{t.replyContent}}?</p>
                      <p class="date">{{format.formatDayTime(t.createDate)}}</p>
                      <!-- <div class="forAsk">
                        <a-button class="pushStudent"
                                  @click="goLookAsk(item)"> 推给学生 </a-button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
        <div style="text-align:center;">
          <a-config-provider>
            <a-pagination :default-current="1"
                          :page-size="pageSize"
                          @change="handleListChange"
                          :total='total' />
          </a-config-provider>
        </div>
      </div>
    </div>
    <a-modal v-model="lookMore"
             width="1100px"
             title=""
             footer="">
      <div class="prepare">
        <p class="askContent">{{allAnswer.content}}</p>
        <div class="replayMess"
             v-for="(t,index) in allAnswer.replyList"
             :key="index">
          <span class="fuhao">回复</span>
          <span class="recuserName">{{t.recuserName=!t.recuserName?'测试':t.recuserName}}</span>
          <a-textarea class="textArea"
                      v-model="t.replyContent"
                      :auto-size="{ minRows: 4, maxRows: 10 }" />
        </div>
      </div>
      <div class="askHelp"
           v-for="(a,inde) in allAnswer.replyList"
           :key="inde">
        <a-button class="ask"
                  @click="replayStu(a.id)">确定</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import format from '../../../utils/format.js'
export default {
  name: 'ExpertReply',
  data () {
    return {
      format,
      resBasePath: this.$resBasePath,
      lookMore: false,
      loading: false,
      allAnswer: '', // 产看全部回答详情
      listData: [], // 问题列表
      pageSize: 5,
      pageNum: 1,
      total: 0
    }
  },
  methods: {
    goHistory () {
      this.$router.go(-1)
    },
    goLookAsk (item) { // 弹窗
      this.lookMore = true
      this.allAnswer = item
    },
    handleListChange (current, pageSize) { //分页查询
      this.pageNum = current
      this.pageSize = pageSize
      this.expertReplyList()
    },
    replayStu (id) { //推送给学生
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/pushExpertReplyToStudent',
        body: { id: id }
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success(res.resultMessage)
          this.lookMore = false
        }
      })
    },
    expertReplyList () {
      const param = {
        userId: this.$getUserInfo().id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getExpertToBeSolve',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listData = res.resultData.list
        }
      })
    }
  },
  mounted () {
    this.expertReplyList()
  }
}
</script>
<style lang="less" scoped>
ul,
li,
p {
  margin: 0;
  padding: 0;
  list-style: none;
}
.question {
  position: relative;
  .load {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }
  .top {
  //  height: 110px;
  //  background-color: #fff;
    position: relative;
    padding: 0 30px;

    .breadcrumb{
      margin: 20px auto ;
      //width: 1200px;
    }

    //.goHistory {
    //  width: 16px;
    //  height: 32px;
    //  cursor: pointer;
    //}
    //.icon {
    //  position: absolute;
    //  top: 50%;
    //  margin-top: -7px;
    //  left: 50px;
    //}
    //.iconText {
    //  position: absolute;
    //  top: 50%;
    //  margin-top: -10px;
    //  left: 100px;
    //  color: #9d9292;
    //  font-size: 24px;
    //}
  }
  .content {
    width: 100%;
    background: #f6f6f6;
    .contMes {
      //width: 1240px;
      background: #fff;
      margin: 0 auto;
      padding: 20px 30px;
      border-radius: 8px;
      .questionSolve {
        text-align: right;
        width: 120px;
        height: 32px;
        background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
        box-shadow: 0px 2px 8px 0px #dbcebc;
        border-radius: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        margin-left: auto;
      }
    }
    .mesList {
      //width: 1140px;
      margin: 0 auto;
      background: #f6f6f6;
      margin-top: 20px;
      border-radius: 8px;
    }
  }
}
// 查看全部回答公用样式
.prepare {
  .prepareTop {
    padding: 20px;
  }
  .bookName {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #9d9292;
  }
  .bookTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 0px;
    color: #000000;
    margin: 10px 0px;
  }
  .spanImg {
    width: 44px;
    height: 44px;
    display: inline-block;
  }
  .photoImg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .userName {
    font-size: 18px;
    color: #000;
    line-height: 26px;
  }
  .fuhao {
    font-size: 18px;
    color: #9d9292;
    margin-left: 0px;
    line-height: 26px;
  }
  .userSchool {
    font-size: 18px;
    color: #9d9292;
    margin-left: 10px;
    line-height: 26px;
  }
  .questionText {
    font-size: 20px;
    line-height: 30px;
    color: #040506;
  }
  .date {
    color: #9d9292;
    font-size: 14px;
  }
  .forAsk {
    text-align: right;
    font-family: PingFangSC-Semibold;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    height: 45px;
    letter-spacing: 0px;
    .pushStudent {
      width: 120px;
      height: 32px;
      line-height: 32px;
      background-color: @primary-color;
      color: #fff;
      border-radius: 4px;
    }
  }
  .askContent {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #000000;
  }
  .recuserName {
    color: @primary-color;
    font-size: 18px;
    margin-left: 10px;
  }
}
.ulList {
  margin-top: 10px;
  .listMes {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #9d9292;
    height: 30px;
    line-height: 30px;
  }
}
.askHelp {
  height: 60px;
  width: 100%;
  background: #fff;
  .ask {
    width: 120px;
    height: 32px;
    background-color: @primary-color;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    float: right;
    margin-top: 14px;
  }
}
.mesMore {
  height: 360px;
  padding: 20px;
}
.footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}
.answerMes {
  .answerText {
    font-size: 16px;
    color: #9d9292;
  }
  .answerName {
    color: @primary-color;
    font-size: 18px;
    margin-left: 20px;
  }
  .answerTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #000000;
    margin-top: 10px;
  }
  .answerBgc {
    margin-top: 10px;
    background-color: #f6f6f6;
  }
  /deep/.ant-input {
    background-color: #f6f6f6;
  }
}
.textArea {
  margin-top: 10px;
}
.zjcontent {
  padding: 20px;
  .title {
    height: 50px;
    font-family: PingFangSC-Semibold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #db5647;
    text-align: center;
  }
  .proplem {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 46px;
    letter-spacing: 0px;
    color: #040506;
    text-align: center;
    .name {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: @primary-color;
    }
  }
  .zjFooter {
    text-align: center;
    margin-top: 10px;
    .cancle {
      width: 160px;
      height: 44px;
      background: #f6f6f6;
      color: #9d9292;
      font-size: 18px;
    }
    .sure {
      width: 160px;
      height: 44px;
      background: #f6f6f6;
      background-color: @primary-color;
      font-size: 18px;
      color: #fff;
      margin-left: 30px;
    }
  }
}
.replayMess {
  background: #fff;
  padding-top: 10px;
  .photoImg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  /deep/.ant-input {
    background: #f6f6f6;
  }
}
.clearFix {
  clear: both;
}
/deep/.ant-modal-header {
  border-bottom: none;
}
/deep/.ant-modal-title {
  font-size: 24px;
  color: #000000;
}
/deep/.ant-list-pagination {
  text-align: center;
  margin-top: 0px;
  background: #fff;
}
/deep/.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}
/deep/.ant-list-split .ant-list-item {
  border-bottom: none;
}
/deep/.ant-list-something-after-last-item
  .ant-spin-container
  > .ant-list-items
  > .ant-list-item:last-child {
  border-bottom: none;
}
/deep/.ant-list-lg .ant-list-item {
  padding: 0px;
}
/deep/.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 0px;
}
/deep/.ant-pagination {
  padding-top: 10px;
}
</style>
